var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailIconBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 26,
    viewBox: "0 0 53 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.84764,
    y: 1.07469,
    width: 34.6897,
    height: 22.9411,
    rx: 2.14938,
    fill: "#1D4F97",
    stroke: "white",
    strokeWidth: 2.14938
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8709 14.4876L9.97999 5.10581C8.09298 3.91693 8.93525 1 11.1656 1H40.9473C43.1776 1 44.0199 3.91692 42.1329 5.10581L27.242 14.4876C26.5175 14.944 25.5953 14.944 24.8709 14.4876Z",
    fill: "#1D4F97",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5215 12.364L9.77686 22.4899M30.0284 12.364L42.7729 22.4899",
    stroke: "white",
    strokeWidth: 2.14938
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconBlue);
export default __webpack_public_path__ + "static/media/mailIconBlue.1fcbd1e70dd4ec50d1d9d657915d3df1.svg";
export { ForwardRef as ReactComponent };